<a *ngIf="objTitle" 
    [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" 
    [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams"
    (mouseenter)="isHoverCard = true" (mouseleave)="isHoverCard = false"
>
    <div *ngIf="dataCorsi" class="container-general-small h-100 no-print" [ngClass]="{'p-1 p-md-0': isNews}">
        <div class="container-general-small__container-image position-relative">
            <img loading="lazy" *ngIf="dataCorsi.field_immagine" [src]="imgPath"
                class="container-general-small__container-image__image h-100 w-100" [alt]="image_alt">
            <img loading="lazy" *ngIf="!dataCorsi.field_immagine" class="h-100 w-100"
                src="../../../../../../assets/images/rectangle_gradient.png" alt="'Course | Lumsa'">
            <div *ngIf="dataCorsi.field_classe_di_laurea"
                class="container-general-small__container-image__badge ls-label-small-semibold text-brand-40 bg-brand-90 position-absolute top-0 left-0">
                <p class="m-0 ls-label-small-semibold" [innerHTML]="dataCorsi.field_classe_di_laurea"></p>
            </div>
        </div>
        <div class="container-general-small__container-description bg-neutral-A1 d-flex flex-column justify-content-between">
            <div class="container-general-small__container-description__container-text">
                <p class="text-neutral-60 ls-label-small-semibold text-uppercase" *ngIf="dataCorsi.field_tipo_di_corso"
                    [innerHTML]="dataCorsi.field_tipo_di_corso"></p>
                    <h3 class="text-brand-10 mb-3 text-decoration-none ls-h3-item-title-small cursor-pointer"
                        [hreflang]="objTitle.hreflang" [innerHTML]="objTitle.title"></h3>
            </div>
            <div class="container-general-small__container-description__icon">
                <span *ngIf="dataCorsi.langs">{{dataCorsi.langs}}</span>
            </div>
        </div>
        <!-- HOVER -->
        <div class="container-general-small__container-description-hover bg-neutral-A1 d-flex flex-column justify-content-between">
            <div>
                <div class="container-general-small__container-description-hover__container-text">
                    <a *ngIf="objTitle" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                        <h3 class="text-brand-10 mb-3 text-decoration-none ls-h3-item-title-small cursor-pointer"
                            [hreflang]="objTitle.hreflang" [innerHTML]="objTitle.title"></h3>
                    </a>
                </div>
                <div class="container-general-small__container-description-hover__table">
                    <div class="container-general-small__container-description-hover__table__item">
                        <p class="mb-custom-4 ls-label-small-semibold text-neutral-30 text-uppercase">
                            {{"BLOCK.SAMPLE_CARD_CORSI.TYPE" | translate}}</p>
                        <p class="m-0 ls-label-small-semibold text-neutral-60 text-uppercase"
                            [innerHTML]="dataCorsi.field_tipo_di_corso"></p>
                    </div>
                    <div
                        class="container-general-small__container-description-hover__table__item d-flex justify-content-between">
                        <div class="container-general-small__container-description-hover__table__item__text col-6">
                            <p class="mb-custom-4 ls-label-small-semibold text-neutral-30 text-uppercase">
                                {{"BLOCK.SAMPLE_CARD_CORSI.DEPARTMENT" | translate}}</p>
                            <p class="m-0 ls-label-small-semibold text-neutral-60 text-uppercase"
                                *ngFor="let item of dataCorsi.field_tassonomia_dipartimenti; let idx = index;"
                                [innerHTML]="idx !== (dataCorsi.field_tassonomia_dipartimenti.length - 1) ? item.name + ', ' : item.name">
                            </p>
                        </div>
                        <div class="container-general-small__container-description-hover__table__item__text col-6">
                            <p class="mb-custom-4 ls-label-small-semibold text-neutral-30 text-uppercase"
                                [innerHTML]="'città'">
                            </p>
                            <p class="m-0 ls-label-small-semibold text-neutral-60 text-uppercase"
                                *ngFor="let item of dataCorsi.field_citta_corso; let idx = index;"
                                [innerHTML]="idx !== (dataCorsi.field_citta_corso.length - 1) ? item + ', ' : item">
                            </p>
                        </div>
                    </div>
                    <div
                        class="container-general-small__container-description-hover__table__item d-flex justify-content-between">
                        <div class="container-general-small__container-description-hover__table__item__text col-6">
                            <p class="mb-custom-4 ls-label-small-semibold text-neutral-30 text-uppercase">
                                {{"BLOCK.SAMPLE_CARD_CORSI.DURATION" | translate}}</p>
                            <p class="m-0 ls-label-small-semibold text-neutral-60 text-uppercase"
                                [innerHTML]="dataCorsi.field_durata"></p>
                        </div>
                        <div class="container-general-small__container-description-hover__table__item__text col-6">
                            <p class="mb-custom-4 ls-label-small-semibold text-neutral-30 text-uppercase">
                                {{"BLOCK.SAMPLE_CARD_CORSI.CREDITS" | translate}}</p>
                            <p class="m-0 ls-label-small-semibold text-neutral-60 text-uppercase"
                                [innerHTML]="dataCorsi.field_cfu_ects"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-general-small__container-description-hover__icon">
                <span *ngIf="dataCorsi.langs">{{dataCorsi.langs}}</span>
            </div>
        </div>
        <!-- END HOVER -->
    </div>
</a>

<!-- *ngIf="dataCorsi.field_immagine" [src]="imgPath" -->
<app-sample-print 
    [taxonomy]="dataCorsi.field_classe_di_laurea" 
    [title]="objTitle.title" 
    [imageUrl]="dataCorsi.field_immagine && imgPath ? imgPath : ''">
</app-sample-print>